import { FC, useRef } from 'react';
import { AuthWindow } from './AuthWindow';
import { useSelector } from 'react-redux';
import { authorizedSelector, selectIsWidgetOpen } from '../../selectors/auth';
import { dispatchWidgetEvent, EAnalyticsEventType, EAuthWidgetEventName } from '../../utils/dispatchWidgetEvent';

interface ILoginWidgetB2CProps {}

export const LoginWidgetB2C: FC<ILoginWidgetB2CProps> = () => {
  const authorized = useSelector(authorizedSelector);
  const isWidgetOpen = useSelector(selectIsWidgetOpen);
  const ref = useRef<HTMLDivElement | HTMLButtonElement | null>(null);

  function handleSuccessfulAuth(advertisingAgreementChecked: boolean = false) {
    dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Authorization);

    if (advertisingAgreementChecked) {
      dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onAdvertisingConsent);
    }
  }

  function handleShowScreens(isSmsWindowShows: boolean) {
    if (isSmsWindowShows) {
      dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onCodeScreenShown);
    } else {
      dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Analytics, EAnalyticsEventType.onPhoneScreenShown);
    }
  }

  function handleCloseModal() {
    dispatchWidgetEvent(ref.current, EAuthWidgetEventName.Close);
  }

  if (!authorized && isWidgetOpen) {
    return (
      <AuthWindow
        ref={ref as React.MutableRefObject<HTMLDivElement | null>}
        onAuth={handleSuccessfulAuth}
        handleShowScreens={handleShowScreens}
        handleCloseModal={handleCloseModal}
      />
    );
  }

  return null;
};
